import React, { useState } from 'react'
import { Stack, Typography, SvgIcon, Fade } from '@mui/material'
import { DonutChartData, UnifiedDonutCharts } from '../../../../shared/components/DonutCharts'
// import { ReactComponent as FiltersIcon } from '../../../../assets/images/Filters.svg'
import { ReactComponent as HeadsetIcon } from '../../../../assets/images/headset.svg'
import LoadingBackdrop from '../../../../shared/components/LoadingBackdrop/LoadingBackdrop'
import useImpactMetrics from './useImpactMetrics'
import MetricsCards from '../../../../shared/components/MetricsCards'
import useValueMessageDisplayName from '../../../../shared/hooks/useDisplayNames/variants/useValueMessageDisplayName'
import List from '../components/List'
import { ValueMessage } from '../../../ValueNarrativesView/queries/useGetValueNarrativesQuery'
import { EmptyPlaceholder } from '../../../../shared/components/EmptyPlaceholder'

const ImpactMetricsTab = () => {
    const { cards, data, legend, isLoading } = useImpactMetrics()

    const valueMessageDisplayName = useValueMessageDisplayName()

    const [listData, setListData] = useState<DonutChartData<ValueMessage>>(null)

    if (isLoading) {
        return <LoadingBackdrop loading title="Metrics" subtitle="Loading Impact Metrics" />
    }

    const title = `${valueMessageDisplayName.singular} Support`
    const isEmpty = !data.length

    // @TODO metrics - implement empty placeholder for all charts
    return (
        <Fade in timeout={800}>
            <Stack direction="column">
                {/*<Stack direction="row" alignItems="center" gap={1} mb={2}>*/}
                {/*    <Typography variant="18x600" color="figma.grayscale.textHier1">*/}
                {/*        Impact metrics*/}
                {/*    </Typography>*/}
                {/*    <Tooltip title="Coming soon..." enterDelay={600} enterNextDelay={600} arrow>*/}
                {/*        <Stack*/}
                {/*            sx={{*/}
                {/*                cursor: 'not-allowed',*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            <SvgIcon*/}
                {/*                component={FiltersIcon}*/}
                {/*                inheritViewBox*/}
                {/*                fontSize="small"*/}
                {/*                sx={{*/}
                {/*                    fontSize: '24px',*/}
                {/*                    color: 'figma.grayscale.tier5',*/}
                {/*                }}*/}
                {/*            />*/}
                {/*        </Stack>*/}
                {/*    </Tooltip>*/}
                {/*</Stack>*/}

                <Stack direction="row" alignItems="center" gap={1} color="figma.grayscale.textHier1" mb={1}>
                    <SvgIcon
                        component={HeadsetIcon}
                        inheritViewBox
                        fontSize="small"
                        color="inherit"
                        sx={{ fontSize: '24px' }}
                    />
                    <Typography variant="20x500" color="inherit">
                        {title}
                    </Typography>
                </Stack>

                {isEmpty && (
                    <Stack
                        flex={1}
                        direction="column"
                        gap={1}
                        px={2}
                        py={2.75}
                        bgcolor="figma.grayscale.tier7"
                        borderRadius="16px"
                    >
                        <EmptyPlaceholder title="" subtitle="No data to display" />
                    </Stack>
                )}
                {!isEmpty && <UnifiedDonutCharts data={data} legend={legend} onTotalClick={setListData} />}

                <List
                    data={listData}
                    legend={legend}
                    handleClose={() => setListData(null)}
                    getName={(valueMessage) => valueMessage.name}
                    getPathname={(valueMessage) => {
                        if (!valueMessage?.categoryId || !valueMessage?.narrativeId) return null

                        return (
                            '/narratives/categories/' +
                            valueMessage.categoryId +
                            '/narratives/' +
                            valueMessage.narrativeId +
                            '/messages/' +
                            valueMessage._id
                        )
                    }}
                />

                <MetricsCards cards={cards} />
            </Stack>
        </Fade>
    )
}

export default ImpactMetricsTab
